module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"charactersLimit":"The maximum number of characters is","enterTheCorrectAnswer":"Enter the correct answer*","enterTheAnswer":"Enter the answer*","noCorrectAnswer":"No correct answer","showTheCorrectAnswer":"Show the correct answer","requiredField":"This field is required"}}')
  delete Component.options._Ctor
}
